import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import { Star } from 'lucide-react';

const testimonials = [
  {
    name: 'Mariana Silva',
    role: 'Proprietária — Atelier de Bolos (MS)',
    text: 'Antes eu ficava até de madrugada tentando entender boleto de DAS e guia de INSS. Hoje chega uma mensagem no WhatsApp falando "Mari, é só pagar esse aqui até dia 20". Pronto. Foi isso que me fez respirar.',
    stars: 5,
    img: 'https://images.unsplash.com/photo-1527154341204-319eeba2d06e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxicmF6aWxpYW4lMjBidXNpbmVzcyUyMG93bmVyJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzc2NDgwNTc0fDA&ixlib=rb-4.1.0&q=85&w=200&h=200',
  },
  {
    name: 'Carlos Eduardo',
    role: 'CEO — Tech Solutions (GO)',
    text: 'Já passei por 3 contadores antes. Dois sumiam quando eu precisava, um só falava difícil. A FinContex responde rápido e explica como se a gente fosse amigo. Minha folha e impostos nunca foram tão tranquilos.',
    stars: 5,
    img: 'https://images.unsplash.com/photo-1505455221201-c5249c8d9599?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxicmF6aWxpYW4lMjBidXNpbmVzcyUyMG93bmVyJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzc2NDgwNTc0fDA&ixlib=rb-4.1.0&q=85&w=200&h=200',
  },
  {
    name: 'Ana Beatriz Rocha',
    role: 'MEI — Consultoria de Marketing',
    text: 'Abri meu MEI com eles e achei que ia ser complicado. Não foi. Me explicaram cada passo, me avisaram o que eu podia e o que eu não podia fazer, e até hoje sempre que surge dúvida eu mando no WhatsApp e me respondem no mesmo dia.',
    stars: 5,
    img: null,
  },
];

export default function Testimonials() {
  const sectionRef = useScrollAnimation();

  return (
    <section
      id="depoimentos"
      data-testid="testimonials-section"
      ref={sectionRef}
      className="py-24 md:py-32 bg-[#F8FAFC]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Header */}
        <div className="scroll-fade text-center mb-16 md:mb-20">
          <p className="text-sm uppercase tracking-[0.2em] font-semibold text-[#10B981] mb-4">
            Depoimentos
          </p>
          <h2
            className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#0A2540] tracking-tight leading-tight"
            style={{ fontFamily: "'Inter', sans-serif", letterSpacing: '-1px' }}
          >
            O que nossos clientes dizem
          </h2>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 stagger-children">
          {testimonials.map((t) => (
            <div
              key={t.name}
              data-testid={`testimonial-card-${t.name.toLowerCase().replace(/\s/g, '-')}`}
              className="scroll-fade bg-white p-8 border border-slate-200 rounded-xl hover:-translate-y-1 transition-transform duration-300 flex flex-col"
            >
              {/* Stars */}
              <div className="flex gap-1 mb-5">
                {Array.from({ length: t.stars }).map((_, i) => (
                  <Star key={i} size={16} className="fill-[#10B981] text-[#10B981]" />
                ))}
              </div>

              {/* Quote */}
              <p className="text-slate-700 leading-relaxed mb-6 flex-1 italic">
                "{t.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-slate-100">
                {t.img ? (
                  <img
                    src={t.img}
                    alt={t.name}
                    className="w-10 h-10 rounded-full object-cover"
                  />
                ) : (
                  <div className="w-10 h-10 rounded-full bg-[#0A2540] flex items-center justify-center text-white text-sm font-bold">
                    {t.name.split(' ').map((n) => n[0]).join('')}
                  </div>
                )}
                <div>
                  <p className="text-sm font-semibold text-[#0A2540]">{t.name}</p>
                  <p className="text-xs text-slate-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
